export function meltenEffect(elemId, translateValue = 60, transitionValue = 1) {
  const elem = document.getElementById(elemId);
  const yPos = elem.getBoundingClientRect().y;
  const winSize = window.innerHeight;
  const opp = yPos - translateValue + 100 < winSize ? 1 : 0;
  const trans = yPos - translateValue + 100 < winSize ? 0 : translateValue;
  elem.style['transition'] = `${transitionValue}s`;
  elem.style['opacity'] = `${opp}`;
  elem.style['transform'] = `translateY(${trans}px)`;
}

export async function scrollNum(elemId, number, ordTriggerValue = 950, status) {
  const elem = document.getElementById(elemId);
  const rect = elem.getBoundingClientRect();
  if (rect.y > ordTriggerValue && rect.y < ordTriggerValue + 100) {
    for (let i = 0; i <= number; i++) {
      await new Promise((resolve, reject) => setTimeout(resolve, 80));
      elem.innerHTML = i;
    }
    elem.innerHTML = number;
  }
}

export function animeLogo() {

  setTimeout(() => {
    document.getElementById("header-logo").style['transform'] = `translateX(0px) rotate(0deg)`;
    document.getElementById("header-logo").style['opacity'] = `100`;
  }, 1000);
}
